import { Component, OnInit } from '@angular/core';
import {
  JeevesCustomerDetailsComponent
} from 'gung-standard-jeeves';

import { first } from 'rxjs';

@Component({
  selector: 'cult-customer-details',
  templateUrl: './cult-customer-details.component.html',
  styleUrls: ['./cult-customer-details.component.scss'],
  standalone: false
})
export class CultCustomerDetailsComponent extends JeevesCustomerDetailsComponent implements OnInit {
  isUserNoHistory = false;
  currentUser;
  isSales = false;

  ngOnInit() {
    const routeParams = this.route.snapshot.params;
    if (routeParams.customerId != null) {
      this.customerService
        .getCustomer(routeParams.customerId)
        .pipe(first())
        .subscribe(customer => {
          this.jeevesCustomerDeliveryLocationListConfigService.customerId = customer && customer.id;
          this.customer = customer;
        });
    }
    this.authService.getCurrentUser().subscribe(user => {
      this.currentUser = user;
      this.isActuator = user.roles.indexOf('ACTUATOR') > -1;
      this.isUserNoHistory = user.roles.includes('USER_NOHISTORY');
      this.isSales = user.roles.indexOf('SALES') > -1 || user.roles.indexOf('ADMIN') > -1;
    });
  }
}
